import Image from 'next/image';
import React, { useEffect, useRef } from 'react';

const videoSrc = '/assets/gift-cards/gift-cards-preview.mp4';
const imageFallbackSrc = '/assets/gift-cards/gift-cards-preview-fallback.png';

export const GiftCardVideo: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          videoElement.play();
        } else {
          videoElement.pause();
        }
      },
      { threshold: 0.5 },
    );

    observer.observe(videoElement.parentElement as Element);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="h-full md:px-10 md:mx-auto md:my-20 md:h-screen">
      <video
        ref={videoRef}
        loop
        controls
        autoPlay
        playsInline
        muted
        className="w-full h-full mx-auto"
        poster={imageFallbackSrc}>
        <source src={videoSrc} type="video/mp4" />
        <Image
          src={imageFallbackSrc}
          alt="Fallback image for Gift Cards Video"
          layout="responsive"
          width={1920}
          height={1080}
        />
      </video>
    </div>
  );
};
